import { Dispatch } from "redux";
import {
  getContactById,
  setContactModalState,
} from "../../../pages/app/Manage/InstituteProfile/service/instituteSlice";

export function openContactExpandModal(id: string, dispatch: Dispatch) {
  dispatch(setContactModalState());
  dispatch<any>(getContactById(id));
}
